import React from 'react';
import styled from 'styled-components';

import getColor from 'happytree';

import { disabledStyles } from '../Button.styles';
import SecondaryButton, { SecondaryButtonProps } from './SecondaryButton';

export type TertiaryButtonProps = SecondaryButtonProps;

const StyledButton = styled(SecondaryButton)<TertiaryButtonProps>`
  background-color: ${({ bg }) => bg};
  border: 0;

  ${({ isSelected, color = 'primary' }) =>
    isSelected
      ? ` 
    background-color: ${getColor(color)};
    color: ${getColor('background')};
    `
      : ''}

  ${({ isDisabled, bg }) =>
    isDisabled &&
    `
    ${disabledStyles}
    background-color: ${bg};
    border: 0;
  `}
`;

const S = {
  TertiaryButton: StyledButton,
};

function TertiaryButton(
  { bg = 'transparent', ...props }: TertiaryButtonProps,
  ref: TertiaryButtonProps['ref'],
) {
  return <S.TertiaryButton {...props} ref={ref} bg={bg} />;
}

export default React.forwardRef(TertiaryButton);
